import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

/**
 * The Alerts Dashboard legend's per-code choices. Sparse on purpose: a code with
 * no entry falls back to `isAlertTypeEnabledByDefault`, so a DEV code added after
 * a choice was persisted still starts hidden. Persisted, unlike `eventFilter`;
 * the collapsed toggle shows the hidden count so a restored filter is visible.
 */
export interface AlertFilterState {
  overrides: Record<string, boolean>;
}

const initialState: AlertFilterState = { overrides: {} };

export const alertFilterSlice = createSlice({
  name: 'alerts/filter',
  initialState,
  reducers: {
    alertTypeSet: (
      state,
      { payload }: PayloadAction<{ code: string; enabled: boolean }>,
    ) => {
      state.overrides[payload.code] = payload.enabled;
    },
    alertTypesSet: (
      state,
      {
        payload,
      }: PayloadAction<{ codes: readonly string[]; enabled: boolean }>,
    ) => {
      for (const code of payload.codes) {
        state.overrides[code] = payload.enabled;
      }
    },
    alertFilterReset: state => {
      state.overrides = {};
    },
  },
});

export const alertFilterActions = alertFilterSlice.actions;
